import type { Locale } from '../i18n'

export interface SettingsLocaleRow {
  id: Locale
  label: string
  selected: boolean
}

export interface SettingsOverlayOptions {
  title: string
  pitch: string
  languageTitle: string
  audioTitle: string
  backLabel: string
  locales: SettingsLocaleRow[]
  audioLabel: string
  audioOn: boolean
  onLocale: (locale: Locale) => void
  onAudio: () => void
  onBack: () => void
}

export interface SettingsOverlayHandle {
  setAudio: (label: string, on: boolean) => void
  setNote: (text: string) => void
  destroy: () => void
}

export function mountSettingsOverlay(options: SettingsOverlayOptions): SettingsOverlayHandle {
  const root = document.createElement('div')
  root.className = 'game-settings-overlay'

  const panel = document.createElement('section')
  panel.className = 'game-settings-panel'

  const header = document.createElement('header')
  header.className = 'game-settings-header'
  const title = document.createElement('h1')
  title.textContent = options.title
  const pitch = document.createElement('p')
  pitch.textContent = options.pitch
  header.append(title, pitch)

  const note = document.createElement('p')
  note.className = 'game-settings-note'
  note.hidden = true

  const language = document.createElement('section')
  language.className = 'game-settings-card'
  const languageTitle = document.createElement('h2')
  languageTitle.textContent = options.languageTitle
  const languageList = document.createElement('div')
  languageList.className = 'game-settings-language-list'
  for (const locale of options.locales) {
    const btn = document.createElement('button')
    btn.type = 'button'
    btn.className = 'game-settings-language'
    btn.dataset.selected = locale.selected ? '1' : '0'
    btn.textContent = `${locale.selected ? '● ' : ''}${locale.label}`
    btn.addEventListener('click', () => options.onLocale(locale.id))
    languageList.append(btn)
  }
  language.append(languageTitle, languageList)

  const audio = document.createElement('section')
  audio.className = 'game-settings-card'
  const audioTitle = document.createElement('h2')
  audioTitle.textContent = options.audioTitle
  const audioButton = document.createElement('button')
  audioButton.type = 'button'
  audioButton.className = 'game-settings-audio'
  audioButton.addEventListener('click', options.onAudio)
  audio.append(audioTitle, audioButton)

  const back = document.createElement('button')
  back.type = 'button'
  back.className = 'game-settings-back'
  back.textContent = options.backLabel
  back.addEventListener('click', options.onBack)

  panel.append(header, note, language, audio, back)
  root.append(panel)
  document.body.append(root)

  const setAudio = (label: string, on: boolean): void => {
    audioButton.textContent = label
    audioButton.dataset.on = on ? '1' : '0'
  }
  setAudio(options.audioLabel, options.audioOn)

  return {
    setAudio,
    setNote: (text) => {
      note.textContent = text
      note.hidden = !text
    },
    destroy: () => root.remove(),
  }
}
